var FlexAppointmentModel = require("../models/FlexAppointmentModel");
var AbstractWS = require("./AbstractWS");

function ListViewAppointmentsWS(viewModel, moment) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;

  this.MOMENT_DATE_FORMAT="YYYY-MM-DD"

  self.appointments = ko.observableArray([]);
  // Convenience name for debugging
  self.name = 'ListViewAppointmentsWS';

  this.dataType = "xml";


	/**
	 * Defines the string to request API services
	 *
	 * @method serviceURL
	 * @returns {String}
	 */
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/appointments/headers';
  });


	/**
	 * Overload to prevent service from being called before the QueueID
   * has been set
	 *
	 * @method doRequest
	 * @param {Function} fCallback
   * @param {Object} date
	 * @returns none
	 */
  self.doRequest = function (fCallback, date) {
    if (date) {
      self.addParam('queueIds', self.queueIds());
      self.addParam('start', date.start);
      self.addParam('end', date.end);
    } else {
      var today = moment().format(this.MOMENT_DATE_FORMAT);
      var tomorrow = moment().add(1, "days").format(this.MOMENT_DATE_FORMAT)

      self.addParam('queueIds', self.queueIds());
      self.addParam('start', today);
      self.addParam('end', tomorrow);
    }

    self.addParam('timeZone', moment.tz.guess())

    AbstractWS.prototype.doRequest.call(self, fCallback);
  };


	/**
	 * This method iterates over the data returned from the service and
	 * converts the individual nodes into LocationModels and then assigns
	 * them to this object's locations collection.
	 *
	 * @method processData
	 * @param {object} data JSON FlexAppointments
	 * @returns {ListViewAppointmentsWS}
	 */
  self.processData = function (data) {
    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, data);

    if (data.appointments) {
      // Make sure the appointment collection is an array
      var appointments = Array.makeArray(data.appointments.appointment);
      self.appointments(appointments.map(self.createAppointment.bind(self)));
    }

    return self;
  };


  /**
   * Returns a string of queue ids from the root
   * ViewModel of queues that have appointments
   * available
   * 
   * @method queueIds
   * @returns {String}
   */
  self.queueIds = ko.deferredComputed(function () {
    var queues = self.parent.parent.selectedQueues();

    if (queues && queues.length) {
      return queues.reduce(function (arr, q) {
        if (q.appointmentsEnabled) {
          arr.push(q)
        }
        return arr;
      }, []).map(function (q) {
        return q.id
      }).join(',');
    }

    return '';
  }, self);


	/**
	 * Returns the object to it's initial state
	 *
	 * @method reset
	 * @returns none
	 */
  self.reset = function () {
    // Remove any spots
    self.spots.removeAll();

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.reset.call(self);
  };

  return self;
};

ListViewAppointmentsWS.prototype = Object.create(AbstractWS.prototype);
ListViewAppointmentsWS.prototype.constructor = ListViewAppointmentsWS;


/**
 * Create a Flex Appointment object/record
 *
 * @param {object} appointmentData FlexAppointment record
 * @return {FlexAppointmentModel}
 */
ListViewAppointmentsWS.prototype.createAppointment = function (appointmentData) {
  var appointment = new FlexAppointmentModel(appointmentData);

  // Populate Location
  if (appointment.location.id) {
    // FIX: Why does this reference a GLOBAL variable?
    // var l = vm.locationsWS.getLocationById(a.locationId);
    var l = this.parent.parent.locationsWS.getLocationById(
      appointment.location.id
    );

    if (l) {
      appointment.location.description = l.description;
    }
  }

  return appointment;
};

module.exports = ListViewAppointmentsWS
